module.exports = __webpack_public_path__ + "static/img/routedes2.911b11f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/routedes2.png
// module id = /2ae
// module chunks = 0